import * as React from 'react';
import { Popup } from 'semantic-ui-react';
import { i18n as I18n } from 'i18next';
import { getI18n } from 'services/i18n-service';
import { getCleanDate } from 'helpers/date-helper';
import { translations } from 'types/translations';
import { OperationItem } from 'types/operation-item';
import { LanguageCode } from 'types/tenants/language-code';

import './styles.css';

export interface Props {
  language: LanguageCode;
  trigger: JSX.Element;
  operationItem: OperationItem;
}

export class InfoIconPopup extends React.Component<Props> {
  render() {
    const i18n = getI18n();

    var rendProps;
    if ('properties' in this.props.operationItem.epc) {
      rendProps = Object.keys(this.props.operationItem.epc.properties).map((propertyName, i) => {
        return (
          <span className="scanned-date-time response-time" key={i}>
            <strong>{propertyName}</strong>:
            &nbsp;{this.props.operationItem.epc.properties[propertyName]}
          </span>
        );
      });
    } else {
      rendProps = '';
    }

    return (
      // hide on scroll so the popup does not travel with the scrolling
      <Popup trigger={this.props.trigger} className="info-icon-popup" hideOnScroll={true}>
        <span className="scanned-date-time response-time">
          <strong>{i18n.t(translations.ScannedDateTime)}</strong>:&nbsp;
          <span className="value">{getCleanDate(this.props.operationItem.scanDatetime)}</span>
        </span>
        {rendProps}
      </Popup>
    );
  }

  getResponseTime = (responseTime: number | null | undefined, i18n: I18n): string => {
    if (!responseTime || responseTime === 0) {
      return i18n.t(translations.NotApplicable);
    }

    return responseTime.toFixed(2) + '  ' + i18n.t(translations.Seconds).toLowerCase();
  }
}


// WEBPACK FOOTER //
// ./src/components/operation-grid/cells/info-icon/popup.tsx